Namespace 'CustomerVisualMode'

class CustomerVisualMode.WidgetValueTranslatorFactory
  create: (dimension) ->
    new CustomerVisualMode.NullValueTranslator
